// src/data/servicesData.js

const servicesData = {
  "/education": {
    title: "Education",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Academy</strong>, located in Karachi, is an educational
          initiative of Khadija-tul-Kubra Welfare Trust. The Academy provides separate
          facilities for <em>Baneen</em> (boys) and <em>Banat</em> (girls), ensuring a
          comfortable and focused learning environment. Currently, more than 300 students
          are enrolled, receiving a well-rounded education that combines both religious and
          contemporary subjects.
        </p>

        <p>
          In addition to its core programs, the Trust extends its educational services
          through the following initiatives:
        </p>

        <ul>
          <li>Awarding monthly scholarships to deserving school and college students.</li>
          <li>Offering adult education programs to promote literacy and lifelong learning.</li>
          <li>Conducting weekend classes for professionals to enhance their knowledge and skills.</li>
          <li>Distributing Quranic manuscripts to schools and mosques in remote areas.</li>
          <li>Providing free textbooks and notebooks to underprivileged students.</li>
          <li>Establishing and supporting modern primary education in a school located in Mirpur Khas.</li>
          <li>
            Launching lectures, speeches, and social media campaigns to emphasize the value
            of education in society.
          </li>
        </ul>

        <p>
          Through these efforts, Khadija-tul-Kubra Academy strives to nurture individuals
          with strong moral values, sound religious knowledge, and the skills needed to
          thrive in the modern world.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Education/education1.jpg?updatedAt=1747391197062",
      "https://ik.imagekit.io/nfs93gxmp/Education/education2.jpg?updatedAt=1747391197101",
      "https://ik.imagekit.io/nfs93gxmp/Education/education3.jpg?updatedAt=1747391197113",
      "https://ik.imagekit.io/nfs93gxmp/Education/education4.jpg?updatedAt=1747391197072"
    ]
  },

 "/orphans-support": {
  title: "Orphans Support – Himaya Program - Dare-Khadija",
  description: (
    <>
      <p>
        <strong>Himaya</strong>—an Arabic word meaning “protection”—is the dedicated orphan
        care program of Khadija-tul-Kubra Welfare Trust. True to its name, the program
        extends care, shelter, and support to orphans without distinction of color, caste,
        tribe, or religion. Our goal is to nurture them with dignity, compassion, and
        opportunities for a brighter future.
      </p>

      <p>Under Himaya, the following services are provided:</p>
      <ul>
        <li>Management and supervision of the orphanage Dar-e-Khadija.</li>
        <li>Financial assistance to support the daily needs of orphans.</li>
        <li>Educational sponsorships, ensuring access to quality learning opportunities.</li>
        <li>Medical support for health and well-being.</li>
        <li>
          Assistance for marriages of orphan girls, helping them begin new chapters in life
          with dignity.
        </li>
        <li>
          Organizing curricular and co-curricular activities and inter-orphanage
          competitions to foster talent, confidence, and personal growth.
        </li>
      </ul>

      <p>
        Through Himaya, Khadija-tul-Kubra Welfare Trust strives not only to provide care
        but also to build futures filled with hope, opportunity, and protection.
      </p>

      <h3>Dar-e-Khadija</h3>
      <p>
        For orphans, <strong>Dar-e-Khadija</strong> is more than a shelter—it is the embrace
        of a compassionate mother. It is a place where children are not only cared for but
        also nurtured, guided, and empowered to turn their dreams into reality,
        Insha’Allah.
      </p>

      <p>At Dar-e-Khadija, we provide:</p>
      <ol>
        <li>Safe and standard accommodation, along with clothing and medical facilities.</li>
        <li>Nutritious meals prepared and served according to strict hygiene standards.</li>
        <li>A blend of contemporary and religious education to shape well-rounded individuals.</li>
        <li>
          <em>Tarbiyah</em> and <em>Tazkiyah</em> (moral and spiritual development) to help
          children lead good, pious lives.
        </li>
        <li>
          Life skills that prepare them to be responsible Muslims and productive members of
          society.
        </li>
        <li>Sports and recreational opportunities for physical health and positive engagement.</li>
        <li>
          Vocational training to enable self-sufficiency and financial independence in
          adulthood.
        </li>
      </ol>

      <p>
        Dar-e-Khadija is not just an orphanage—it is a home of love, guidance, and growth,
        where every child is valued, supported, and inspired to build a dignified future.
      </p>
    </>
  ),
  images: [
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/orphan1.jpg?updatedAt=1747391865915",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/orphan3.jpg?updatedAt=1747391865177",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/orphan2.jpg?updatedAt=1747391865307",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/orphan4.jpg?updatedAt=1747391865278",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.53.44%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.54.46%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.53.59%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.54.47%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.55.24%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.55.16%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.56.02%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.56.36%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.56.37%20PM.jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.56.36%20PM%20(1).jpeg",
    "https://ik.imagekit.io/nfs93gxmp/Orphanage/WhatsApp%20Image%202025-10-13%20at%203.56.36%20PM.jpeg"
  ]
},
 "/water-supply": {
    title: "Water Supply Projects",
    description: (
      <>
        <p>
          <strong>Water Supply Projects</strong> <br />
          <em>(Hand Pumps • Solar Water Plants • RO Plants)</em>
        </p>

        <p>
          Alhamdulillah, Khadija-tul-Kubra Welfare Trust has worked tirelessly to provide
          access to clean drinking water in underserved communities. To date, we have
          successfully implemented <strong>200 water projects</strong> across different
          regions, including <strong>28 solar-powered water plants</strong> and{" "}
          <strong>38 hand pumps</strong>.
        </p>

        <p>
          These initiatives are delivering safe and clean water to nearly{" "}
          <strong>40,000 people</strong> living in remote and water-scarce areas. Beyond
          human consumption, thousands of animals are also benefiting from these projects,
          contributing to healthier families, communities, and livelihoods.
        </p>

        <p>
          We firmly believe that those who contribute to such projects earn the ongoing
          blessings and rewards of Allah Almighty. As long as water continues to flow and
          lives continue to benefit, the <em>Sadaqah Jariyah</em> (everlasting charity) of
          our supporters will continue, Insha’Allah.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.57.15%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.56.50%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.56.15%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.55.56%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.54.46%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.54.45%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.54.45%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Water%20Supply/WhatsApp%20Image%202025-10-17%20at%203.54.45%20PM.jpeg"
    ]
  },
  // src/data/servicesData.js
  // ... previous services

  "/food-supply": {
    title: "Food Supply Programs",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> is committed to alleviating
          hunger and providing nutritious food to those in need. Currently, our Food
          Department serves over <strong>50,000 families</strong> through a variety of
          initiatives:
        </p>

        <ul>
          <li>
            <strong>Ration Distribution:</strong> During the COVID-19 lockdown,{" "}
            <strong>5,000 deserving families</strong> received essential ration packages.
            Currently, <strong>150 needy families</strong> receive monthly ration support.
          </li>
          <li>
            <strong>Naiki Kee Tokri:</strong> Hundreds of people benefit from free daily
            bread distribution through this initiative.
          </li>
          <li>
            <strong>Emergency Relief:</strong> In times of crisis, our team provides cooked
            meals to affected communities.
          </li>
          <li>
            <strong>Hospital Support:</strong> <strong>150 needy individuals</strong>{" "}
            visiting hospitals in Karachi daily receive packed cooked meals.
          </li>
          <li>
            <strong>Ramadan Support:</strong> Large-scale Ramadan ration packages are
            distributed annually; in 2024, <strong>3,000 families</strong> received support
            during the holy month.
          </li>
          <li>
            <strong>International & Special Projects:</strong> Contributions also extend to
            humanitarian efforts such as the <em>Gaza Project</em>, providing flour and
            cooked Qurbani meat to those in need.
          </li>
        </ul>

        <p>
          Through these efforts, the Trust ensures that both immediate hunger and
          nutritional needs are addressed, reflecting our commitment to serving humanity
          with compassion, dignity, and consistency.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.30%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.31%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.31%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.32%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.32%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.33%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.33%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.34%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.35%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.35%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.36%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Food%20Supply/WhatsApp%20Image%202025-10-16%20at%207.18.36%20PM.jpeg"
    ]
  },

  "/iftar-packages": {
    title: "Iftar Packages",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> proudly organizes{" "}
          <em>Iftar programs</em> every year during Ramadan, bringing the blessings of the
          holy month to those in need.
        </p>

        <ul>
          <li>
            Every day during Ramadan, <strong>650 individuals</strong> break their fast
            through our arrangements.
          </li>
          <li>
            Alhamdulillah, to date, we have successfully provided Iftar for over{" "}
            <strong>75,000 fasting people</strong>.
          </li>
          <li>
            Iftar is distributed both through <em>collective dining arrangements</em> as
            well as <em>individual parcels</em>, ensuring accessibility and convenience for
            all recipients.
          </li>
        </ul>

        <p>
          Through these programs, the Trust strives to promote community spirit,
          compassion, and the shared joy of Ramadan while supporting those who are less
          fortunate.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Iftar/iftar1.jpg?updatedAt=1747394500000",
      "https://ik.imagekit.io/nfs93gxmp/Iftar/iftar2.jpg?updatedAt=1747394501000",
      "https://ik.imagekit.io/nfs93gxmp/Iftar/iftar3.jpg?updatedAt=1747394502000",
      "https://ik.imagekit.io/nfs93gxmp/Iftar/iftar4.jpg?updatedAt=1747394503000"
    ]
  },
   "/quilts-clothing": {
    title: "Supply of Quilts & Clothing",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> provides essential clothing and
          quilts to needy families, particularly during major occasions such as{" "}
          <em>Eid-ul-Fitr</em> and <em>Eid-ul-Adha</em>, ensuring comfort, dignity, and joy
          for underprivileged communities.
        </p>

        <ul>
          <li>
            To date, the Trust has distributed <strong>Eid clothes and shoes</strong> to
            over <strong>3,000 children, men, and women</strong>.
          </li>
          <li>
            Seasonal clothing is provided to those living in remote settlements, including{" "}
            <em>light clothing, slippers, and shoes during summer</em> and{" "}
            <em>warm clothes during winter</em>.
          </li>
          <li>
            In total, more than <strong>10,000 children, men, and women</strong> have
            benefited from our clothing and quilt distribution programs.
          </li>
        </ul>

        <p>
          Through these initiatives, the Trust aims to alleviate hardship, spread happiness
          during festive occasions, and ensure that basic needs are met for the most
          vulnerable members of society.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.07.35%20PM%20(1).jpeg?updatedAt=1760376876595",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.07.36%20PM.jpeg?updatedAt=1760376876459",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.07.35%20PM%20(2).jpeg?updatedAt=1760376876412",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.08.12%20PM%20(2)%20-%20Copy.jpeg?updatedAt=1760376876280",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.04.37%20PM.jpeg?updatedAt=1760376876112",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.04.36%20PM%20(2).jpeg?updatedAt=1760376876112",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.04.36%20PM%20(1).jpeg?updatedAt=1760376876047",
      "https://ik.imagekit.io/nfs93gxmp/Quilt%20and%20Clothing/WhatsApp%20Image%202025-10-13%20at%204.08.12%20PM.jpeg?updatedAt=1760376876043"
    ]
  },
  "/holy-papers-protection": {
    title: "Protection of Holy Papers",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> is dedicated to the respectful
          handling and disposal of sacred texts. Through this initiative, the Trust ensures
          that Quranic manuscripts and other holy papers are managed with dignity and care.
        </p>

        <ul>
          <li>
            More than <strong>50 customized collection boxes</strong> have been installed
            outside mosques in <em>DHA, Karachi</em>, as well as other public areas, to
            allow people to safely deposit damaged, old, or unused Quranic manuscripts and
            other sacred texts.
          </li>
          <li>
            Twice a month, a dedicated team collects the deposited papers and ensures they
            are <strong>buried respectfully in accordance with Islamic guidelines</strong>.
          </li>
        </ul>

        <p>
          This program not only provides a convenient way for the community to dispose of
          sacred texts but also upholds the dignity and reverence due to our religious
          heritage.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.38%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.38%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.38%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.38%20PM%20(3).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.38%20PM%20(4).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.39%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.39%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.39%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.39%20PM%20(3).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/quranic%20auraaq/WhatsApp%20Image%202025-10-18%20at%205.24.39%20PM%20(4).jpeg"
    ]
  },

  "/self-sufficiency-projects": {
    title: "Self-Sufficiency Projects",
    description: (
      <>
        <p>
          At <strong>Khadija-tul-Kubra Welfare Trust</strong>, we believe that while
          meeting the immediate needs of the underprivileged is a noble act, empowering
          them to become self-reliant is even more impactful. Our Self-Sufficiency
          Projects aim to provide employment, vocational support, and sustainable income
          opportunities so that individuals can stand on their own feet and contribute
          positively to society.
        </p>

        <p>Initiatives under the Self-Sufficiency Program include:</p>
        <ul>
          <li>Provision of rickshaws to unemployed individuals.</li>
          <li>
            Distribution of livestock, such as <em>sheep and goats</em>, to generate income
            through dairy and breeding.
          </li>
          <li>
            Establishment of stalls with saleable items to support small-scale businesses.
          </li>
          <li>Distribution of sewing machines for tailoring businesses.</li>
          <li>Investments and shop setups to enable sustainable livelihoods.</li>
          <li>
            Technical and vocational training to enhance skills and employability.
          </li>
        </ul>

        <p><strong>Impact so far:</strong></p>
        <ul>
          <li>
            15 individuals were provided <strong>stalls</strong> along with{" "}
            <strong>Rs. 5,000</strong> each to purchase trade goods.
          </li>
          <li>
            1 woman received <strong>2 goats</strong> to generate income through milk and
            breeding.
          </li>
          <li>
            2 unemployed persons were each provided with a{" "}
            <strong>new auto rickshaw</strong>.
          </li>
          <li>
            Ongoing projects are focused on <em>technical courses</em> for skilled
            individuals, expanding opportunities for long-term self-reliance.
          </li>
        </ul>

        <p>
          Through these initiatives, the Trust strives not only to alleviate poverty but
          also to foster <strong>independence, dignity, and sustainable livelihoods</strong>{" "}
          for deserving members of society.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/WhatsApp%20Image%202025-10-13%20at%203.42.16%20PM%20(2).jpeg?updatedAt=1760380081367",
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/WhatsApp%20Image%202025-10-13%20at%203.43.30%20PM%20(1).jpeg?updatedAt=1760380081370",
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/WhatsApp%20Image%202025-10-13%20at%203.44.51%20PM.jpeg?updatedAt=1760380081370",
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/WhatsApp%20Image%202025-10-13%20at%203.43.30%20PM.jpeg?updatedAt=1760380081338",
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/WhatsApp%20Image%202025-10-13%20at%203.44.16%20PM.jpeg?updatedAt=1760380081275",
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/WhatsApp%20Image%202025-10-13%20at%203.42.52%20PM.jpeg?updatedAt=1760380081248",
      "https://ik.imagekit.io/nfs93gxmp/SelfSufficient/selfsuffic1.jpg?updatedAt=1747392221807"
    ]
  },
  "/marriage-assistance": {
    title: "Marriage Assistance for Underprivileged Girls",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> is committed to supporting
          families who face financial challenges in marrying off their daughters. Rising
          costs make this an overwhelming burden for many, and the Trust seeks to ease
          this struggle with dignity and compassion.
        </p>

        <p><strong>Support provided includes:</strong></p>
        <ul>
          <li>Financial assistance for wedding expenses.</li>
          <li>
            <strong>Wedding attire:</strong> 20 girls have been provided with dresses for
            their special day.
          </li>
          <li>
            <strong>Dowry support:</strong> 15 girls received essential items and clothing
            to start their new lives.
          </li>
          <li>
            <strong>Event support:</strong> Provision of food and catering for the wedding
            celebrations.
          </li>
        </ul>

        <p>
          Through these initiatives, the Trust helps families celebrate weddings with{" "}
          <strong>joy and dignity</strong>, while empowering young women to begin their
          married lives with <strong>confidence and respect</strong>.
        </p>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/WhatsApp%20Image%202025-10-13%20at%203.51.57%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/WhatsApp%20Image%202025-10-13%20at%203.51.56%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/WhatsApp%20Image%202025-10-13%20at%203.51.56%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/WhatsApp%20Image%202025-10-13%20at%203.51.56%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/WhatsApp%20Image%202025-10-13%20at%203.51.19%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/WhatsApp%20Image%202025-10-13%20at%203.50.55%20PM.jpeg"
    ]
  },
   "/disaster-relief": {
    title: "Emergency Relief",
    banner: "https://ik.imagekit.io/nfs93gxmp/Marriage%20Support/12Emergency.jpg",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> is dedicated to providing
          immediate and effective assistance to communities affected by disasters,
          epidemics, or emergencies. Leveraging a network of volunteers, the Trust ensures
          timely support in critical areas, including:
        </p>

        <ul>
          <li>Awareness campaigns to educate affected communities.</li>
          <li>Provision of food and safe drinking water.</li>
          <li>Medical assistance for those in need.</li>
          <li>Shelter for displaced families.</li>
          <li>Child care and protection services.</li>
          <li>Rehabilitation support to restore livelihoods and normalcy.</li>
        </ul>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.05.53%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.07.17%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.07.47%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.08.11%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.09.05%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.09.35%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.09.53%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.10.12%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.10.35%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.10.53%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.10.53%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/WhatsApp%20Image%202025-10-16%20at%202.11.13%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/reliefpak4.jpg?updatedAt=1747392449200",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/reliefpak.jpg?updatedAt=1747392449135",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/reliefpak2.jpg?updatedAt=1747392449039",
      "https://ik.imagekit.io/nfs93gxmp/Relief%20Activities%20pakistan/reliefpak3.jpg?updatedAt=1747392449014"

    ]
  },

   "/health-support": {
    title: "Health Support",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> is committed to providing accessible and quality healthcare to underserved communities. Our initiatives include:
        </p>

        <ul>
          <li>Medical Treatment: Needy patients receive treatment through partner hospitals and clinics.</li>
          <li>Free Medicines: Essential medicines are provided to those who cannot afford them.</li>
          <li>Financial Assistance: Funding is offered to cover medical expenses for deserving patients.</li>
          <li>Impact: To date, approximately 7,000 individuals have benefited from our healthcare support.</li>
          <li>Clinic Services: Regular medical services are provided at a clinic in Gadap Town, Ahsanabad, and a fully equipped clinic operates in the Achhrothar Desert, Khapro Tehsil.</li>
          <li>Ambulance Service: An operational ambulance in DHA, Karachi, ensures timely medical assistance during emergencies.
Through these healthcare initiatives, the Trust aims to improve the well-being of communities, reduce suffering, and ensure that medical care is available to those who need it most.
</li>
        </ul>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.39.45%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.39.45%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.41.46%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.44.21%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.45.05%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.45.36%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.46.12%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.48.43%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.48.50%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.48.58%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.39.45%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.41.14%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.42.01%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.42.56%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Health%20SUpport/WhatsApp%20Image%202025-10-17%20at%205.49.08%20PM.jpeg"
    ]
  },
   "/quranic-institutes-network": {
    title: "Quranic Institutes Network",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong>has established a network of over 40 Quranic schools in underprivileged areas across Pakistan, inclding Thar, Tando Allahyar, Mirpur Khas, Khushab, and Sakran.
        </p>

        <ul>
          <li>These institutes provide quality religious education to more than 3,000 boys and girls, helping them develop a strong foundation in Quranic studies, Islamic values, and moral character.</li>
          <li>Through this network, the Trust strives to preserve Islamic knowledge, promote literacy, and empower young generations in underserved communities.</li>
        </ul>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%204.01.18%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%204.00.53%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%204.00.52%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%203.57.42%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%203.57.42%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%203.57.41%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%203.58.46%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%203.59.42%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%203.59.19%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Quranic-institutes/WhatsApp%20Image%202025-10-13%20at%204.00.53%20PM.jpeg"
    ]
  },

  "/construction-and-management-of-mosques": {
    title: "Construction and Management of Mosques",
    description: (
      <>
        <p>
          <strong>Khadija-tul-Kubra Welfare Trust</strong> committed to the construction and management of mosques, particularly in remote, underprivileged, and densely populated areas.
        </p>

        <ul>
          <li>Management: The Trust oversees the management and financial operations of the Khadija-tul-Kubra Mosque in Karachi, ensuring smooth administration and proper use of resources.</li>
          <li>Construction: Building mosques is a key priority of the Trust. To date, 8 mosques have been constructed in areas such as Mahendro Par (Thar), Talhar (Badin), and Khorowha (Badin). Surveys for additional mosque projects are underway, targeting communities in need of spiritual and social infrastructure.</li>
          <li>Community Participation: Supporters can participate in the construction of new mosques as a means of earning spiritual rewards for themselves and their loved ones, contributing to the expansion of worship and community development in underserved areas.</li>
          
        </ul>
      </>
    ),
    images: [
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.47.56%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.47.56%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.47.56%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.48.13%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.48.32%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.50.10%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.50.10%20PM%20(1).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.50.10%20PM%20(2).jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.50.11%20PM.jpeg",
      "https://ik.imagekit.io/nfs93gxmp/Mosque%20Construction/WhatsApp%20Image%202025-10-13%20at%203.50.11%20PM%20(1).jpeg"
    ]
  },

  // Alias paths used by home page / footer (same content as existing routes)
  "/releif-activity-pakistan": null,
  "/self-sufficiency-plans": null,
};

// Resolve aliases to existing service data
servicesData["/releif-activity-pakistan"] = servicesData["/disaster-relief"];
servicesData["/self-sufficiency-plans"] = servicesData["/self-sufficiency-projects"];

export default servicesData;
